export function validatePhone(min: number): Function {
  return (value: string) => {
    value = value.split(' ').join('').split('-').join('').split('(').join('').split(')').join('').split('+').join('');
    if (!value || value.length === 0 ) {
      return true;
    }

    return value.length >= min;
  }
}

export function validateCPF(value: any) {
  var cpfNumber = value || '';

  let validateCPF = cpfNumber.replace(/[-. ]/g, '')

  if(validateCPF.length === 0) {
    return true;
  }

  if (validateCPF.length === 11) {
    var soma;
    var resto;
    soma = 0;
    if (validateCPF === "00000000000") return false;

    for (let i = 1; i <= 9; i++) soma = soma + parseInt(validateCPF.substring(i - 1, i)) * (11 - i);
    resto = (soma * 10) % 11;

    if ((resto === 10) || (resto === 11)) resto = 0;
    if (resto !== parseInt(validateCPF.substring(9, 10))) return false;

    soma = 0;
    for (let i = 1; i <= 10; i++) soma = soma + parseInt(validateCPF.substring(i - 1, i)) * (12 - i);
    resto = (soma * 10) % 11;

    if ((resto === 10) || (resto === 11)) resto = 0;
    if (resto !== parseInt(validateCPF.substring(10, 11))) return false;

    return true;
  }

  return false;
}

export function validateEmail(value: any) {
  if(value.length === 0) {
    return false;
  }

  var email = value;
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
}

export function validateRecoveryEmail(form: any): Function {
  return (value: string) => {
    const values = form.getValues()
    let userEmail = values.email

    if(!value || value.length === 0){
      return true
    }

    let recoveryEmail = value;
    let re = /\S+@\S+\.\S+/;

    if(recoveryEmail === userEmail){
      return false
    }

    return re.test(recoveryEmail);
  }
}

export function validateRecoveryEmailChange(value: unknown): true | string {
  const v = typeof value === "string" ? value.trim() : "";
  if (!v.length) {
    return "Informe o e-mail de recuperação.";
  }
  if (!/\S+@\S+\.\S+/.test(v)) {
    return "E-mail inválido.";
  }
  return true;
}

export function validateRepeatRecoveryEmailChange(form: {
  getValues: (name: string) => string;
}): (value: unknown) => true | string {
  return (value: unknown) => {
    const a = typeof value === "string" ? value.trim() : "";
    const b = (form.getValues("recoveryEmail") ?? "").trim();
    if (a !== b) {
      return "Os e-mails não coincidem.";
    }
    return true;
  };
}

/** Alinhado aos fluxos OAuth (Angular/React): símbolos # ! @ $ % ^ & * */
const PASSWORD_ALLOWED_CHARS = /^[A-Za-z0-9!#@$%^&*]+$/;
const PASSWORD_SPECIAL_CHARS = /[!#@$%^&*]/;

/** Mensagens específicas para o usuário corrigir a senha (react-hook-form aceita string como erro). */
export function validatePassword(value: unknown): true | string {
  const v = typeof value === 'string' ? value : '';

  if (v.length === 0) {
    return 'Informe uma senha.';
  }

  if (v.length < 8 || v.length > 16) {
    return 'A senha deve ter entre 8 e 16 caracteres.';
  }

  if (!PASSWORD_ALLOWED_CHARS.test(v)) {
    return 'Use apenas letras, números e os símbolos # ! @ $ % ^ & *.';
  }

  if (!/[a-z]/.test(v)) {
    return 'Inclua pelo menos uma letra minúscula.';
  }

  if (!/[A-Z]/.test(v)) {
    return 'Inclua pelo menos uma letra maiúscula.';
  }

  if (!/\d/.test(v)) {
    return 'Inclua pelo menos um número.';
  }

  if (!PASSWORD_SPECIAL_CHARS.test(v)) {
    return 'Inclua pelo menos um destes símbolos: # ! @ $ % ^ & *.';
  }

  return true;
}

export function validateCountryState(form: any): Function {
  return (value: string) => {
    const values = form.getValues()
    if(values.physicianIdentificationNumber.length === 0) {
      return true;
    }

    if(value.length === 0) {
      return false;
    }
    
    return true;
  }
}

export function validateCRM(value: string) {
  if(!value || value.length === 0) {
    return false;
  }

  const valueInNumber = Number(value);

  if(Number.isNaN(valueInNumber)) {
    return false;
  }

  if(valueInNumber === 0) {
    return false;
  }

  return true;
}

export function validateRepeatPassword(form: any): Function {
  return (value: string) => {
    const values = form.getValues();
    const pwd = typeof values.password === 'string' ? values.password : '';

    if (!value || value.length === 0) {
      return 'Confirme sua senha.';
    }

    if (pwd !== value) {
      return 'As senhas não coincidem.';
    }

    return true;
  };
}